import React, { Component } from 'react';

import Slider from '../../../../../../Shared/React/js/components/sliders/Slider';

export default class ModalMaxUpfrontSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rawValue: null
        };

        this.handleSliderValueChanged = this.handleSliderValueChanged.bind(this);
        this.handleSliderValueUpdating = this.handleSliderValueUpdating.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        return props.value === state.rawValue ? { rawValue: null } : null;
    }

    handleSliderValueChanged(value) {
        this.props.actions.changeMaxUpfront(value);
    }

    handleSliderValueUpdating(value) {
        console.log(value);

        this.setState({
            rawValue: value
        });
    }

    getDisplayText(value) {
        if (value === -1) {
            return this.props.anyPriceLabel;
        } else if (value === 0) {
            return this.props.values.find(v => v.key === value).value;
        }

        return this.props.values.find(v => v.key === value).value;
    }

    render() {
        const value = this.state.rawValue !== null ? this.state.rawValue : this.props.current;

        const current = !value && value !== 0 ? -1 : value;

        return (
            <React.Fragment>
                <div className="font-5">
                    {this.props.titleLabel}: <strong>{this.getDisplayText(current)}</strong>
                </div>
                <div className="rc-slider-container pad-x-3 pad-x-5-xs mar-y-2">
                    <Slider
                        data={this.props.values.map(a => a.key)}
                        current={current}
                        onValueChanged={this.handleSliderValueChanged}
                        onValueUpdating={this.handleSliderValueUpdating}
                    />
                </div>
            </React.Fragment>
        );
    }
}
